<table-delivery [sales]="sales"></table-delivery>